import slider from "./modules/slider";
import header from "./modules/header";
import nav from "./modules/nav";
import lightbox from "./modules/lightbox";
import popup from "./modules/popup";
import anim from "./modules/anim";
import counter from "./modules/counter";
import notice from "./modules/notice";
import form from "./modules/form";
import tabs from "./modules/tabs";
import tooltips from "./modules/tooltips";
import calculator from "./modules/calculator";
import sort from "./modules/sort";

document.addEventListener('DOMContentLoaded', function() {
    slider();
    header();
    nav();
    lightbox();
    popup();
    anim();
    counter();
    notice();
    form();
    tabs();
    tooltips();
    calculator();
    sort();
});